import { render } from "./SocialMediaPost.vue?vue&type=template&id=0bc2527d&scoped=true"
import script from "./SocialMediaPost.vue?vue&type=script&lang=js"
export * from "./SocialMediaPost.vue?vue&type=script&lang=js"

import "./SocialMediaPost.vue?vue&type=style&index=0&id=0bc2527d&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc2527d"]])

export default __exports__